<template>
  <div class="wealfare_module">
    <div class="module_inner_cup">
      <!-- money & time -->
      <div class="wel_item_cup">
        <div class="wel_item">
          <div class="wel_item_icon">
            <i class="iconfont iconxinzidaiyu wicon"></i>
          </div>
          <div class="wel_item_text">
            <span class="high_word">薪资待遇：</span>
            <span>面议</span>
          </div>
        </div>
        <div class="wel_item">
          <div class="wel_item_icon">
            <i class="iconfont icongongzuoshijian wicon"></i>
          </div>
          <div class="wel_item_text">
            <span class="high_word">工作时间：</span>
            <span>周一至周五 9:00 - 17:30</span>
          </div>
        </div>
      </div>
      <!-- wealfare -->
      <div class="wel_item_cup">
        <div class="wel_hive">
          <div class="wel_item_icon">
            <i class="iconfont iconfulidaiyu wicon"></i>
          </div>
          <div class="wel_item_text">
            <span class="high_word">福利待遇：</span>
          </div>
        </div>
        <div class="wel_hive_items">
          <div v-for="(witem,index) in wealfare" :key="index" class="wel_hive_info">
            <span class="wel_sub"><i :class="witem.icon" class="wel_hive_icon"></i>{{witem.name}}</span>
          </div>
        </div>
      </div>
      <!-- email -->
      <div class="wel_item_cup">
        <div class="wel_item">
          <div class="wel_item_icon">
            <i class="iconfont iconyouxiang wicon"></i>
          </div>
          <div class="wel_item_text">
            <span class="high_word">招聘邮箱：</span>
            <span>rlzyb@chiaic.com</span>
          </div>
        </div>
        <div class="wel_explain">
          （注：应聘者可发送主题为：“应聘人员姓名 + 岗位”的简历至招聘邮箱或通过智联招聘投递简历）
        </div>
      </div>
      <!-- phone & contactor -->
      <div class="wel_item_cup">
        <div class="wel_item">
          <div class="wel_item_icon">
            <i class="iconfont iconlianxiren wicon"></i>
          </div>
          <div class="wel_item_text">
            <span class="high_word"> 联系人：</span>
            <span>王老师</span>
          </div>
        </div>
        <div class="wel_item">
          <div class="wel_item_icon">
            <i class="iconfont iconlianxidianhua wicon"></i>
          </div>
          <div class="wel_item_text">
            <span class="high_word"> 联系电话：</span>
            <span>19937908971</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jobList } from '@/api/frontApi/join';
export default {
  data() {
    return {
      wealfare: [
        { icon: 'iconfont iconzhoumoshuangxiu', name: '周末双休' },
        { icon: 'iconfont iconbanchejiesong', name: '班车接送' },
        { icon: 'iconfont iconshitangcanbu', name: '食堂餐补' },
        { icon: 'iconfont iconjixiaojiangjin', name: '绩效奖金' },
        { icon: 'iconfont iconwuxianyijin', name: '五险一金' },
        { icon: 'iconfont iconjiejiarifuli', name: '节假日福利' }
      ]
    };
  },
  methods: {
    getJobList() {
      jobList({ pageNo: 1, pageSize: 500 }).then(res => {
        console.log('res');
        console.log(res);
        res.data.list.forEach(item => {
          let tempObj = { content: '', isShow: true, jobId: '' };
          tempObj.content = item.jobBody;
          tempObj.jobId = item.jobId;
          this.jobList.push(tempObj);
        });
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.wealfare_module {
  width: 100%;
  padding: 0 0 20px;

  .module_inner_cup {
    width: 75%;
    margin: 0 auto;
    padding: 15px 20px;
    background-color: #F4F4F5;
  }
}

.wicon {
  font-size: 22px;
  padding-top: 25px;
  color: #139CAC;
}

.wel_item_cup {
  overflow: hidden;
  width: 100%;
  line-height: 45px;
  height: 45px;

  .wel_item {
    float: left;
    width: 30%;
    overflow: hidden;
  }

  .wel_item_icon {
    float: left;
    width: 24px;
  }

  .wel_item_text {
    float: left;
    margin-left: 10px;
  }

  .wel_hive {
    float: left;
    overflow: hidden;
    min-width: 48px;
    margin-right:4px
  }

  .wel_hive_items {
    float: left;
    width: 75%;
    min-width: 720px;
    overflow: hidden;

    .wel_hive_info {
      float: left;
      margin-right: 24px;
      overflow: hidden;
      width: 130px;

      .wel_sub:hover {
        color: #139CAC;
      }
    }

    .wel_hive_icon {
      width: 28px;
      font-size: 24px;
      float: left;
    }
  }

  .wel_explain {
    float: left;
  }
}

.high_word {
  color: #139CAC;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/joinus/welfare.vue